import styled from 'styled-components';
import {Space} from 'antd';

const StyledRowActionCellGhostSpace = styled.div`
  align-items: center;
  display: flex;
  min-width: 56px;
`;

const StyledRowActionCell = styled(Space)`
  align-items: center;

  & > .ant-space-item {
    display: flex;
  }
`;

const StyledRowActionCellWrapper = styled.div`
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
`;


export {
  StyledRowActionCell,
  StyledRowActionCellGhostSpace,
  StyledRowActionCellWrapper,
}
